import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CompositeAnonymousHttpClient } from './CompositeAnonymousHttpClient';
import { AlertPresenter } from '../../AlertPresenter';
import { useEffect } from 'react';

export const FailedAnonymousSessionAlerter: React.FC = () => {
    const anonymousClient = useInstance(CompositeAnonymousHttpClient);
    const alert = useInstance(AlertPresenter);

    useEffect(() => {
        if (anonymousClient.partiallyFailedError){

            const { expiredCareMaps } = anonymousClient.partiallyFailedError;
            const careMapMsg = expiredCareMaps?.length === 1 ? ` to ${expiredCareMaps[0].patientName}'s innerhive` : '';

            alert.showAlertV2({
                header: `We're sorry, the care recipient link you used has expired`,
                message: `If you still need access${careMapMsg}, please ask the owner to generate a new link. You are still able to view the other care recipients you have access to.`
            });
        }
    }, [anonymousClient, alert]);
    return null;
};
